import React from "react";
import moment from "moment";
import styled, { withTheme } from "styled-components";
import EntityList from "../../EntityList/EntityList";
import { CONTRACT_STATUS, CONTROLS_POSITION } from "../../../Common/constants";
import { Link } from "react-router-dom";
import axios from "http/customAxios";
import { BASE_URL } from "../../../request";
import { getPercentage } from "../../../Common/utils";

const StyledClientCell = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
`;

function customEntityToListValuesMapper(dictionaries = { partners: {} }, clients) {
  return ({ entities }) =>
    entities.map(originalEntity => {
      const entity = { ...originalEntity };
      if (originalEntity.status === CONTRACT_STATUS.CANCELLED) {
        entity.status = "baja";
      }
      let partner = undefined;
      if (originalEntity.partner) {
        const entry = Object.entries(dictionaries.partners).find(
          ([k, v]) => v === originalEntity.partner
        );
        if (entry) {
          partner = entry[0];
        }
      }
      entity.partner = partner;
      entity.created = moment(originalEntity.created).format("YYYY-MM-DD");
      entity.updated =
        originalEntity.updated && moment(originalEntity.updated).format("YYYY-MM-DD");
      entity.discount = getPercentage(originalEntity.discount);
      entity.percentagePartner = getPercentage(originalEntity.percentagePartner);
      entity.invoicePartner = originalEntity.invoicePartner ? "Part" : "Dir";
      const client = clients.find(c => c.id.toString() === originalEntity.invoice);
      entity.client = `#${originalEntity.invoice}`;
      entity.clientName = client && client.name;
      entity.idMyS = client && client.idMyS;
      return entity;
    });
}

class ContractsList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      entities: [],
      clients: [],
    };
  }

  componentDidMount() {
    // TODO: replace with httpclient
    axios.get(`${BASE_URL}/api/crm/properties/dictionaries`).then(response => {
      if (response.status === 200 && response.data) {
        this.setState({ dictionaries: response.data });
      }
    });
    // TODO: replace with httpclient
    axios.get(`${BASE_URL}/api/clients?size=10000`).then(response => {
      if (response.status === 200 && response.data) {
        this.setState({ clients: response.data.content || [] });
      } else {
        this.setState({ clients: [] });
      }
    });
  }

  componentWillUnmount() {}

  clientCell = ({ field, entity }) => {
    const fieldName = field && field.fieldName;
    const value = entity && entity[fieldName];
    return (
      <Link
        style={{ color: this.props.theme.regularTextColor }}
        target="_blank"
        title={entity.clientName}
        to={`/crm/clients/${entity.invoice}`}>
        <StyledClientCell>{value}</StyledClientCell>
      </Link>
    );
  };

  idCell = ({ field, entity }) => {
    const fieldName = field && field.fieldName;
    const value = entity && entity[fieldName];
    return (
      <Link
        style={{ color: this.props.theme.regularTextColor }}
        target="_blank"
        to={`/crm/contracts/${value}`}>
        <StyledClientCell>{value}</StyledClientCell>
      </Link>
    );
  };

  render() {
    const {
      name,
      entityName,
      validation,
      fields,
      renderers,
      sorting,
      allowClone,
      allowDelete,
      allowExport,
      exportFileName,
      reorder,
      filterFields,
      showTotalRecords,
    } = this.props.config;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      success,
    } = this.props;
    renderers.client = this.clientCell;
    renderers.id = this.idCell;
    const { dictionaries, clients } = this.state;
    return (
      <EntityList
        filterFields={filterFields}
        loading={loading || !dictionaries}
        entityName={entityName}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        customEntityToListValuesMapper={customEntityToListValuesMapper(dictionaries, clients)}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        currentLocale={this.props.config.locale}
        success={success}
        sorting={sorting}
        allowExport={allowExport}
        exportFileName={exportFileName}
        allowClone={allowClone}
        allowDelete={allowDelete}
        reorder={reorder}
        maxColumnWidth={190}
        horizontalScroll
        controlsPosition={CONTROLS_POSITION.TOP}
        showTotalRecords={showTotalRecords}
        headerLink="/v6/ng/crm/contracts?status=live&clearFilters=true"
        hasFilters
      />
    );
  }
}

ContractsList.propTypes = {};

ContractsList.defaultProps = {};

export default withTheme(ContractsList);
